import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFashion: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconFashion"><Path fillRule="evenodd" clipRule="evenodd" d="M9.00134 3L0.761719 6.5355L2.00134 11L5.00137 10.0281V20.9999H19.0014V10.0281L22.0013 11L23.241 6.5355L15.0013 3C13.9954 6.14311 10.0073 6.14313 9.00134 3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFashion;
